import { getRecommendationBadge } from '@modules/Dashboard/Home/modules/recommendations/utils';
import { Button, useMediaQueryContext } from '@fourthwall/components';
import { DiscordIcon } from '@fourthwall/icons';
import joinDiscord from '@modules/Dashboard/Home/modules/recommendations/assets/join-discord.png';
import React from 'react';
import { useVerifyDiscord } from '@modules/Dashboard/pages/Apps/pages/AppsDiscordVerification';
import { useRecommendationsDismiss } from '@modules/Dashboard/Home/modules/recommendations/useRecommendationsDismiss';
import { useOnboardingSummaryQuery } from '@modules/Dashboard/Home/queries/useOnboardingSummaryQuery';
export const useJoinDiscordRecommendation = () => {
    const media = useMediaQueryContext();
    const { alreadyVerified, openVerificationLink } = useVerifyDiscord();
    const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss();
    const { onboardingSummaryQuery } = useOnboardingSummaryQuery();
    return {
        joinDiscordRecommendation: {
            id: 'joinDiscord',
            enabled: !alreadyVerified && recommendationsDismiss.joinDiscord.visible,
            suggestionProps: {
                type: 'props',
                props: {
                    title: 'Join our Discord community',
                    description: 'Connect with fellow creators in the Fourthwall community',
                    badge: getRecommendationBadge(onboardingSummaryQuery.data?.recommendations.find((item) => item.action.type === 'VerifyDiscord')),
                    content: (React.createElement(Button, { fullWidth: !media.tablet, leftIcon: React.createElement(DiscordIcon, { height: 20, color: "#5865f2" }), label: "Verify and join Discord", analytics: "joinDiscord", onClick: openVerificationLink })),
                    imageUrl: joinDiscord,
                    onDismiss: createOnDismiss(recommendationsDismiss.joinDiscord.dismiss),
                },
            },
        },
    };
};
